/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FlexGrid, Row } from '@carbon/react';

var _excluded = ["children", "className"];
var CardStackedLabeledRows = function CardStackedLabeledRows(_ref) {
  var children = _ref.children,
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement("div", _extends({}, rest, {
      className: classnames('cpc--card__stacked-labeled-rows', className)
    }), /*#__PURE__*/React.createElement(FlexGrid, {
      className: "cds--no-gutter"
    }, /*#__PURE__*/React.createElement(Row, null, children)))
  );
};
CardStackedLabeledRows.propTypes = {
  /**
   * A className to apply to the CardStackedLabeledRows component.
   */
  className: PropTypes.string,
  /**
   * The children to render in the CardStackedLabeledRows component.
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired
};
var CardStackedLabeledRows$1 = CardStackedLabeledRows;

export { CardStackedLabeledRows$1 as default };
